var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEligibilityRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_2791)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5829 28.0543H14.895L14.9631 21.0508H17.6509L17.5829 28.0543Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6392 22.215C17.6392 21.626 17.7887 21.2237 18.1643 20.77C18.1643 20.77 19.3631 19.5785 19.7173 19.1409C19.9775 18.82 20.0636 18.3904 20.0636 18.0875L20.0756 16.9647C20.0756 16.4704 20.3918 16.1022 20.8861 16.1022H20.9108C21.7007 16.0741 22.4198 17.0468 22.4799 18.0268C22.5653 19.4264 21.9662 20.2156 21.5793 20.7313C21.4832 20.8601 21.5766 21.0415 21.7367 21.0415H24.6674C25.2371 21.0415 25.7868 21.5032 25.8168 22.0729C25.8482 22.6693 25.3992 23.1683 24.8215 23.217C24.7908 23.2197 24.8208 23.221 24.8235 23.221C25.2631 23.2251 25.6621 23.5426 25.7061 23.9802C25.7548 24.4646 25.3946 24.8769 24.9296 24.9122C24.9076 24.9142 24.9209 24.9155 24.9409 24.9169C25.3098 24.9436 25.6401 25.2037 25.6994 25.5707C25.7741 26.031 25.4513 26.4326 25.0203 26.486C24.9883 26.49 24.9769 26.5053 25.0036 26.5133C25.3378 26.6201 25.5753 26.9443 25.55 27.3199C25.5226 27.7261 25.1204 28.0537 24.7134 28.0537H17.5825L17.6392 22.215Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1506 31.6386C30.1506 32.5376 29.4218 33.2664 28.5228 33.2664H12.1903C11.2913 33.2664 10.5625 32.5376 10.5625 31.6386V13.1915C10.5625 12.8187 10.6904 12.4573 10.9249 12.1675L14.9732 7.16441C15.2823 6.78246 15.7473 6.56055 16.2387 6.56055H28.5228C29.4218 6.56055 30.1506 7.28933 30.1506 8.18833V31.6386Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6332 8.75195V12.1207C16.6332 13.0234 15.8986 13.7538 14.9959 13.7485L12.4419 13.7335",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_2791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7476,
    height: 27.7524,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityRequest);
export default __webpack_public_path__ + "static/media/EligibilityRequest.60a4d45d6ba7436e36224141fe0b4023.svg";
export { ForwardRef as ReactComponent };